import * as React from 'react';
import * as ReactDOM from 'react-dom';
import SentryReporter from './sentry_reporter';

interface ComponentList {
  [name: string]: any;
}

const KnownComponents = {};

export default function componentLoader(components: ComponentList): void {
  Object.assign(KnownComponents, components);

  Array.from(document.querySelectorAll('*[data-react-class]')).forEach(
    element => {
      const className = element.getAttribute('data-react-class');
      if (className === null) {
        return;
      }
      let Component = components[className];
      if (Component) {
        Component = Component.default ? Component.default : Component;
        const props = JSON.parse(
          element.getAttribute('data-react-props') || '{}',
        );
        ReactDOM.render(
          <SentryReporter>
            <Component {...props} />
          </SentryReporter>,
          element,
        );
      }
    },
  );
}

export function loadKnownComponents(): void {
  componentLoader(KnownComponents);
}

Object.assign(window, { loadKnownComponents });
